import { FC } from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import CustomLink from "components/CustomLink";
import CustomTable from "components/CustomTable";

import { CHAIN_IDS } from "enums/chainIds";

import { formatAccount } from "utils/blockchain";
import { formatUTCSeconds } from "utils/date";

import WebExplorerLinksFactory from "services/blockchain/WebExplorerLinksFactory";

export interface ItemHistory {
  name: string;
  chainId: CHAIN_IDS;
  transactionHash?: string | null;
  updatedAt: number;
  metamaskAddress: string;
  nickname?: string;
  hash?: string | null;
}

interface SectionHistoryProps {
  itemChainId?: CHAIN_IDS;
  itemHistory: ItemHistory[];
  title?: string | null;
}

const SectionHistory: FC<SectionHistoryProps> = ({
  itemChainId,
  itemHistory,
  title = "ITEM HISTORY",
}) => {
  return (
    <>
      <Box width="100%">
        {title && (
          <Typography component="h4" variant="h4" paragraph>
            ITEM HISTORY
          </Typography>
        )}
        <CustomTable
          sx={{
            maxHeight: 220,
          }}
          description="item history"
          columns={[
            {
              id: "action",
              label: "Action",
              sx: { width: 0.2, minWidth: 90 },
            },
            {
              id: "transaction",
              label: "Transaction",
              sx: { width: 0.2, minWidth: 80 },
              // @ts-expect-error add table generics
              render: ({
                chainId,
                transactionHash,
              }: {
                chainId: CHAIN_IDS;
                transactionHash?: string;
              }) =>
                transactionHash ? (
                  <CustomLink
                    href={WebExplorerLinksFactory.tx(chainId, transactionHash)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {formatAccount(transactionHash)}
                  </CustomLink>
                ) : (
                  "-"
                ),
            },
            {
              id: "date",
              label: "Date",
              sx: { width: 0.35, minWidth: 100 },
            },
            {
              id: "user",
              label: "User",
              sx: { width: 0.2, minWidth: 70 },
              // @ts-expect-error add table generics
              render: ({
                chainId,
                item,
              }: {
                chainId: CHAIN_IDS;
                item: ItemHistory;
              }) =>
                item?.transactionHash && (
                  <CustomLink
                    href={WebExplorerLinksFactory.address(
                      chainId,
                      item.metamaskAddress || "",
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.nickname || formatAccount(item.metamaskAddress)}
                  </CustomLink>
                ),
            },
          ]}
          // @ts-expect-error add table generics
          rows={itemHistory.map((item) => ({
            action: item.name,
            transaction: {
              chainId: item.chainId ?? itemChainId,
              transactionHash: item?.transactionHash,
            },
            date: formatUTCSeconds(item.updatedAt / 1000),
            user: { chainId: item.chainId ?? itemChainId, item },
          }))}
        />
      </Box>
    </>
  );
};
export default SectionHistory;
